import {
  Box,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';
import React from 'react';

import Modal from '../../../../../../../components/Modal';

type OfferActionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
};

const OfferActionModal = ({ isOpen, onClose, title, children }: OfferActionModalProps) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  if (isMobile) {
    return (
      <Drawer isOpen={isOpen} onClose={onClose} placement="bottom">
        <DrawerOverlay />
        <DrawerContent borderTopRadius="16px" pb="env(safe-area-inset-bottom)" maxH="85dvh">
          <DrawerCloseButton top="16px" right="16px" />
          {title != null && (
            <Text
              fontFamily="heading"
              fontSize="20px"
              fontWeight="700"
              color="leaseEndBlue"
              pt="28px"
              px="24px"
              pb="4px"
            >
              {title}
            </Text>
          )}
          <Box overflowY="auto">{children}</Box>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        title != null && (
          <Text
            as="span"
            display="block"
            w="100%"
            textAlign="left"
            fontFamily="heading"
            fontSize="22px"
            fontWeight="700"
            color="leaseEndBlue"
          >
            {title}
          </Text>
        )
      }
    >
      {children}
    </Modal>
  );
};

export default OfferActionModal;
